import { useState } from "react";
import { BRAND } from "../config/brand";

const initial = { name: "", email: "", message: "" };

export default function Contact() {
  const [form, setForm] = useState(initial);
  const [errors, setErrors] = useState({});
  const [sent, setSent] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Please enter your name.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Please enter a valid email address.";
    if (form.message.trim().length < 10) e.message = "Please tell us a little more (at least 10 characters).";
    return e;
  };

  const submit = (ev) => {
    ev.preventDefault();
    const e = validate();
    setErrors(e);
    if (Object.keys(e).length === 0) {
      setSent(true);
    }
  };

  const field = (key, label, type = "text", textarea = false) => (
    <div>
      <label htmlFor={`contact-${key}`} className="text-xs font-bold uppercase tracking-[0.18em] text-plum">
        {label}
      </label>
      {textarea ? (
        <textarea
          id={`contact-${key}`}
          rows={5}
          value={form[key]}
          onChange={(ev) => setForm({ ...form, [key]: ev.target.value })}
          aria-invalid={!!errors[key]}
          aria-describedby={errors[key] ? `contact-${key}-error` : undefined}
          data-testid={`contact-${key}-input`}
          className="mt-2 w-full rounded-xl border border-mauve/50 bg-warmwhite px-4 py-3 text-base text-plumcharcoal transition-colors focus:border-plum focus:outline-none"
        />
      ) : (
        <input
          id={`contact-${key}`}
          type={type}
          value={form[key]}
          onChange={(ev) => setForm({ ...form, [key]: ev.target.value })}
          aria-invalid={!!errors[key]}
          aria-describedby={errors[key] ? `contact-${key}-error` : undefined}
          data-testid={`contact-${key}-input`}
          className="mt-2 w-full rounded-xl border border-mauve/50 bg-warmwhite px-4 py-3 text-base text-plumcharcoal transition-colors focus:border-plum focus:outline-none"
        />
      )}
      {errors[key] && (
        <p id={`contact-${key}-error`} role="alert" data-testid={`contact-${key}-error`} className="mt-2 text-sm font-semibold text-rose">
          {errors[key]}
        </p>
      )}
    </div>
  );

  return (
    <main className="bg-ivory pt-[68px]" data-testid="contact-page">
      <div className="mx-auto max-w-[640px] px-5 py-20 sm:px-8 lg:py-24">
        <h1 className="font-serif text-4xl font-medium tracking-tight text-plum sm:text-5xl">
          Contact
        </h1>
        <p className="mt-4 text-base leading-relaxed text-plumcharcoal/75">
          A question about {BRAND.product}, your order or access? Email us at{" "}
          <a href="mailto:support@bloomparentify.com" className="font-semibold text-rose underline underline-offset-2" data-testid="contact-email-link">
            support@bloomparentify.com
          </a>{" "}
          or send a message below — we aim to respond within 2 business days.
        </p>
        {sent ? (
          <div
            role="status"
            data-testid="contact-success"
            className="mt-10 rounded-3xl border border-mauve/35 bg-warmwhite p-8"
          >
            <p className="font-serif text-2xl italic text-plum">Thank you.</p>
            <p className="mt-2 text-sm leading-relaxed text-plumcharcoal/70">
              Your message has been noted. Our full support inbox is being
              connected, and this page will send directly to it soon.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} noValidate className="mt-10 space-y-6" data-testid="contact-form">
            {field("name", "Name")}
            {field("email", "Email", "email")}
            {field("message", "Message", "text", true)}
            <button
              type="submit"
              data-testid="contact-submit-button"
              className="rounded-xl bg-plum px-7 py-4 text-sm font-bold uppercase tracking-[0.1em] text-ivory transition-colors hover:bg-plum/90"
            >
              Send message
            </button>
          </form>
        )}
      </div>
    </main>
  );
}
